import { get, post } from "./base";

const PublicServ = {
    getBanners: (params) => get("/banners", { params: { platform: 'web', ...params } }),
    getTodayDeals: (params) => get("/today-deals", { params }),
    getEndingSoonDeals: (params) => get("/today-deals/ending-soon", { params }),
    getLifestyles: (params) => get("/lifestyles", { params }),
    sendContactRequest: (data) => post("/contact", data),
    getTopShops: (limit) => get("/shops/top", { params: { limit } }),
    getFeaturedCategoryBanners: (params) => get("/banners", { params: { platform: 'web', hasCategory: true, ...params } }),
    subscribeNewsletter: (data) => post("/newsletter/subscribe", data),
};

export default PublicServ;
